export function menu(){
    const header = document.querySelector('header') as HTMLElement | null;
    const headerContainer = header?.querySelector('.header-container') as HTMLElement | null;
    const wrapper = document.querySelector('.button-wrapper') as HTMLElement | null;
    const button = wrapper?.querySelector('.button-fx') as HTMLElement | null;
    if (!header || !headerContainer || !wrapper || !button) return;

    const placeholder = document.createElement('div');
    placeholder.style.display = 'none';
    placeholder.style.width = `${button.offsetWidth}px`;
    placeholder.style.height = `${button.offsetHeight}px`;
    wrapper.appendChild(placeholder);

    const stickyMargin = 0; // отступ от правого края header-container

    function unfix() {
        button.classList.remove('fixed-btn');
        button.style.top = '';
        button.style.left = '';
        button.style.width = '';
        placeholder.style.display = 'none';
    }

    function doFix(headerContainerRect: DOMRect) {
        const btnH = button.offsetHeight;
        const btnW = button.offsetWidth;

        // Центр header-container
        const targetTop = headerContainerRect.top + headerContainerRect.height / 2 - btnH / 2;

        // Координата left для точного совмещения правого края кнопки с правым краем header-container
        const targetLeft = headerContainerRect.right - btnW - stickyMargin;

        button.style.width = `${btnW}px`;
        button.classList.add('fixed-btn');
        button.style.top = `${Math.round(targetTop)}px`;
        button.style.left = `${Math.round(targetLeft)}px`;
        placeholder.style.display = 'block';
    }

    function onScroll() {
        const scrollY = window.scrollY;
        header.classList.toggle('fixed', scrollY > 50);

        const wrapperRect = wrapper.getBoundingClientRect();
        const headerContainerRect = headerContainer.getBoundingClientRect();

        const triggerLine = headerContainerRect.top + headerContainerRect.height / 2;
        const wrapperTop = wrapperRect.top + button.offsetHeight / 2;

        if (wrapperTop <= triggerLine) {
            doFix(headerContainerRect);
        } else {
            unfix();
        }
    }

    function onResize() {
        unfix();
        placeholder.style.width = `${button.offsetWidth}px`;
        placeholder.style.height = `${button.offsetHeight}px`;
        onScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    onScroll();
}